export const digiThemeUuid = "2ddc1c96-5a45-4fe6-abd1-8e65c8990093";
